
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_Card";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_Card__root","card":"wds_1_209_0_Card__card","controls":"wds_1_209_0_Card__controls"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-card-header-padding-vertical":"--wds-card-header-padding-vertical","wds-card-header-padding-horizontal":"--wds-card-header-padding-horizontal","wds-color-fill-surface-raised":"--wds-color-fill-surface-raised","wds-border-radius-surface-raised":"--wds-border-radius-surface-raised","wds-shadow-surface-raised":"--wds-shadow-surface-raised","wds-shadow-focus-standard":"--wds-shadow-focus-standard"}; 




